import React from 'react';
import { useLocation } from 'react-router-dom';
import { ErrorPage } from '../../pages';
import { useComponentDidCatch } from './use-component-did-catch';
import { MESSAGES } from '../../const';

const pathToNavigate = (pathname: string): string => {
  const path = pathname.split('?')[0];
  const segments = path.split('/').filter(Boolean);
  if (segments.length >= 3) {
    return '/' + segments.slice(0, -1).join('/');
  }
  return path;
};

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError?: boolean;
}

export const ErrorBoundary: React.FC<ErrorBoundaryProps & ErrorBoundaryState> = ({
  children,
  ...props
}: ErrorBoundaryProps & ErrorBoundaryState) => {
  const { pathname } = useLocation();
  const [hasError, setHasError] = useComponentDidCatch(props?.hasError);

  const resetError = () => setHasError(false);

  if (hasError)
    return (
      <ErrorPage
        heading={MESSAGES.ERROR_BOUNDARY.HEADING}
        detail={MESSAGES.ERROR_BOUNDARY.DETAIL}
        navigateTo={pathToNavigate(pathname)}
        resetError={resetError}
      />
    );

  return <>{children}</>;
};
